// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var ListFilter$ReactHooksTemplate = require("./listFilter.res.js");
var CheckboxInput$ReactHooksTemplate = require("../../common/CheckboxInput.res.js");

function ListFilterForm(props) {
  var onChange = props.onChange;
  var filter = props.filter;
  return JsxRuntime.jsx("label", {
              children: JsxRuntime.jsx("div", {
                    children: $$Array.of_list(Belt_List.mapWithIndex(ListFilter$ReactHooksTemplate.getList(filter), (function (i, xs) {
                                return JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                            checked: Belt_List.has(ListFilter$ReactHooksTemplate.selected(filter), xs, (function (x, y) {
                                                    return x === y;
                                                  })),
                                            label: xs,
                                            handleChange: (function (param) {
                                                Curry._1(onChange, {
                                                      TAG: "List",
                                                      _0: ListFilter$ReactHooksTemplate.setSelected(xs, filter)
                                                    });
                                              }),
                                            className: "items-center mb-1",
                                            checkboxClassName: "mt-0 custom_checkbox",
                                            labelClassName: "text-sm text-darkcharcoal leading-normal whitespace-normal"
                                          }, String(i));
                              })))
                  })
            });
}

var make = ListFilterForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
